import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { JumpstoryStatistics } from '../models';

export const fetchByAccountRequest = createAction(
  '[Jumpstory Statistics] Fetch by account Request',
  props<{ accountId: string; timeSpans: number[] }>(),
);
export const fetchRequest = createAction(
  '[Jumpstory Statistics] Fetch Request',
  props<{ timeSpans: number[] }>(),
);
export const fetchSuccess = createAction(
  '[Jumpstory Statistics] Fetch Success',
  props<{ jumpstoryStats: JumpstoryStatistics[] }>(),
);
export const fetchFailure = createAction('[Email] Fetch Failure');
export const downloadCSVRequest = createAction(
  '[Jumpstory Statistics] Download CSV Request',
  props<{ accountId: string; timeSpans: number[] }>(),
);
export const downloadCSVSuccess = createAction(
  '[Jumpstory Statistics] Download CSV Success',
);
export const downloadCSVFailure = createAction(
  '[Jumpstory Statistics] Download CSV Failure',
  props<{ error: HttpErrorResponse }>(),
);
